function onScroll(event) {
  const currentPos = window.scrollY + 15;
  const anchors = document.querySelectorAll(".anchor");
  const menuItems = document.querySelectorAll(".navigation__item");

  anchors.forEach(elem => {
    if (
      elem.offsetTop <= currentPos &&
      elem.offsetTop + elem.closest("section").offsetHeight > currentPos
    ) {
      menuItems.forEach(item => {
        item.className = "navigation__item";
        if (
          elem.id === item.firstElementChild.getAttribute("href").slice(1)
        ) {
          item.classList.add("active");
        }
      });
    }
  });
}

export default function scrollMenu (){
    document.addEventListener("scroll", onScroll, false);
}